import ButtonLink from '@components/button-link/ButtonLink';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import theme from '@ui/theme';
import Link from 'next/link';
import React from 'react';

import useStyles from './HowItWorks.style';

const HowItWorksCleaningContainer = () => {
  const { md } = useBreakpoints();
  const { classes } = useStyles();

  return (
    <>
      <Grid
        container
        justifyContent="space-between"
      >
        <Grid
          item
          xs={12}
          md={7}
        >
          <Typography
            id="how-it-works"
            variant="h4Alt"
            className={classes.headerText}
          >
            How it works
          </Typography>
        </Grid>

        <Grid
          item
          style={{ margin: md ? theme.spacing(0) : 'auto' }}
          xs={12}
          md={12}
          lg={2}
        >
          <Button
            variant="contained"
            color="secondary"
            component={ButtonLink}
            href="/home-staging/get-a-quote?step=email"
            className={classes.stagingQuoteButton}
          >
            Get a free staging quote
          </Button>
        </Grid>
      </Grid>

      <Grid
        container
        alignItems="flex-end"
      >
        <Grid
          item
          xs={12}
          md={2}
        >
          <Typography className={classes.infoNum}>
            01
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          md={10}
        >
          <Box className={classes.infoWrapper}>
            <Grid
              container
              alignItems="flex-end"
            >
              <Grid
                item
                xs={12}
                md={5}
              >
                <Typography
                  className={classes.infoHeader}
                  component="h4"
                  variant="h3Alt"
                >
                  Get an instant quote 
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                md={7}
              >
                <Typography
                  className={classes.infoText}
                >
                  We share real time pricing based on the rooms you need, square footage and location.
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Divider className={classes.divider} />

      <Grid
        container
        alignItems="flex-end"
      >
        <Grid
          item
          xs={12}
          md={2}
        >
          <Typography className={classes.infoNum}>
            02
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          md={10}
        >
          <Box className={classes.infoWrapper}>
            <Grid
              container
              alignItems="flex-end"
            >
              <Grid
                item
                xs={12}
                md={5}
              >
                <Typography
                  className={classes.infoHeader}
                  component="h4"
                  variant="h3Alt"
                >
                  Schedule & pay online
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                md={7}
              >
                <Typography
                  className={classes.infoText}
                >
                  Simply choose your date. Then, check out with your credit card or
                  {' '}
                  <Link
                    href="/affirm"
                    target="_blank"
                    style={{ color: '#666' }}
                  >
                  
                    pay over time with Affirm
                  
                  </Link>
                  .
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Divider className={classes.divider} />

      <Grid
        container
        alignItems="flex-end"
      >
        <Grid
          item
          xs={12}
          md={2}
        >
          <Typography className={classes.infoNum}>
            03
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          md={10}
        >
          <Box className={classes.infoWrapper}>
            <Grid
              container
              alignItems="flex-end"
            >
              <Grid
                item
                xs={12}
                md={5}
              >
                <Typography
                  className={classes.infoHeader}
                  component="h4"
                  variant="h3Alt"
                >
                  We do the work for you 
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                md={7}
              >
                <Typography className={classes.infoText}>
                  Our team handles everything from start to finish, while you focus on the important things. 
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default HowItWorksCleaningContainer;
